import {AppContext} from "../../context/AppContext";
import React, {useContext, useEffect, useState} from "react";
import translate from "../../i18n/Translator";
import {
    Fab,
    Grid
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Surface from "../../components/Surface";
import queryString from "query-string";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import CancellationRequestedCfdisTable from "./CancellationRequestedCfdisTable";
import {NonIntegratedCfdi} from "../../model/CfdisNonIntegrated";
import {listCancellationRequested} from "../../api/ProviderNonIntegratedCfdiApi";
import {useWebSocket} from "../../websocket/WebSocketContext";

export default function CancellationRequestedCfdis(){
    const context = useContext(AppContext);
    const tenantId = context.session!.tenant!.id;
    const providerId = context.session?.provider?.id;
    const [status, setStatus] = useState<string>("VERIFYING");

    const [data, setData] = useState<NonIntegratedCfdi[]>([]);
    const [statusCfdis, setStatusCfdis] = useState<string>(
        translate("cfdis_non_integrated.cancellation_requested.verifying") as string);
    const [disableVerifyButton, setDisableVerifyButton] = useState<boolean>(true);
    const qs = queryString.parse(window.location.search);
    const referer = typeof qs["referer"] === "string" ? qs["referer"] as string : undefined;
    delete qs['referer'];
    const { subscribe } = useWebSocket();
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            '& > *': {
                margin: theme.spacing(0.5),
            },
        },
    }));

    const getPendingCancellationCfdis = (validateSat : boolean): Promise<NonIntegratedCfdi[]> => {
        return listCancellationRequested(context.session!.tenant!.id, context.session!.provider!.id, validateSat);
    }

    const getMessageStatus = (state : string) => {
        return translate("cfdis_non_integrated.cancellation_requested." + state) as string;
    }

    const load = (validateSat : boolean) => {
        if (providerId) {
            getPendingCancellationCfdis(validateSat).then(response=>{
                const allCancelled = response.every(cfdi=> cfdi.sat_status === "CANCELLED");
                if(allCancelled || response.length === 0){
                    setDisableVerifyButton(true);
                    setStatus("CANCELLED");
                    setStatusCfdis("");
                }
                else if(!validateSat){
                    const isActive = response.some(cfdi=> cfdi.sat_status === "ACTIVE");
                    if(isActive){
                        setStatus("ACTIVE");
                        setStatusCfdis(getMessageStatus("active"));
                    }else{
                        setStatus("PENDING");
                        setStatusCfdis("");
                    }
                    setDisableVerifyButton(false);
                }
                setData(response);
            });
        }
    };

    const classes = useStyles();

    const backTo = ((): string | undefined => {
        switch (referer) {
            case "to-send":
                return "/provider/cfdis/to-send?" + queryString.stringify(qs);
        }
    })();

    const getColor = (status: string) => {
        switch (status) {
            case "VERIFYING":
                return "#1F679F";
            case "ACTIVE":
                return "#F69450";
            default:
                return "#000000";
        }
    }

    useEffect(() => {
        return subscribe((payload) => {
            if(payload.type === "NON_INTEGRATED_CFDIS_SAT_VALIDATION"){
                load(false)
            }
        });
    }, [subscribe]);

    useEffect(()=>{
        setDisableVerifyButton(true);
        setStatus("VERIFYING");
        setStatusCfdis(getMessageStatus("verifying"));
        load(true);
    }, [tenantId, providerId]);

    return (
        <Surface
            title={
                <Grid container direction="row">
                    <Grid item className={classes.root}>
                        {translate("cfdis_non_integrated.cancellation_requested.title") as string}
                    </Grid>
                </Grid>
            }
            subtitle={translate("cfdis_non_integrated.cancellation_requested.subtitle") as string}
            backButton
            backTo={backTo}
            icon={<MoreVertIcon/>}
            className="PaperPagination PaperTabContainer"
            titleActions={
                <Grid>
                    <Grid container alignItems="center" justify="flex-end" spacing={1}>
                        <Grid item xs="auto">
                            <Fab color="primary" size="small"
                                 title={translate("cfdis_non_integrated.cancellation_requested.actions.verify") as string}
                                 to
                                 onClick={()=>{
                                     setStatusCfdis(getMessageStatus("verifying"));
                                     setStatus("VERIFYING");
                                     setDisableVerifyButton(true);
                                     load(true)
                                 }}
                                 disabled={disableVerifyButton}
                            >
                                <PlaylistAddCheckIcon/>
                            </Fab>
                        </Grid>
                    </Grid>
                </Grid>}
        >
            <Grid container alignItems="flex-start" spacing={1}>
                <Grid item lg="auto" style={{paddingLeft:"10px"}}>
                    <span style={{ color: getColor(status) }}>{statusCfdis}</span>
                </Grid>
            </Grid>

            <div className="focaltec-small">
                <CancellationRequestedCfdisTable data={data}  status={status}/>
            </div>
        </Surface>)

}